import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import CamSelection from "../camera-setting/camera-dropdown";
import AddDeleteTableRows from "../assign-model-table/index";
import PolygonStateHandler from "../polygon/index";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import {
	addOrUpdateAreaSelectionService,
	deleteAreaSelectionService,
	getAllAreaSelectionService,
	getAllModelNamesService,
	getCameraImageService
} from "../../services/api-service";
import './areaselection.css';

const AreaSelection = () => {
	const [points, setPoints] = React.useState([]);
	const [camSelected, setCamSelected] = useState();
	const [rowsData, setRowsData] = useState([]);
	const [currentCameraImage, setCurrentCameraImage] = useState();
	const [allCameraDetails, setAllCameraDetails] = useState([]);
	const [modelDropDownOptions, setModelDropDownOptions] = useState([]);
	const [selectedRowIndex, setSelectedRowIndex] = useState();
	const [isSubmitting, setIsSubmitting] = useState(false);
	const fullImageDetectionArea = [[[0, 1], [0, 0], [1, 0], [1, 1]]];

	const getAllCameraAssignDetails = () => {
		getAllAreaSelectionService()
			.then((response) => {
				setAllCameraDetails(response?.data);
			})
			.catch((err) => {
				toast.error("Error : Failed to get all area selections !!!");
			});
			console.log('second works')
	}

	async function sendDetails() {
		if (!camSelected?.camera_number) {
			toast.warn("Please select camera first !!!");
			return;
		}

		if (rowsData) {
			if (rowsData?.length === 0) {
				toast.warn("Please assign model first !!!");
				return;
			}
		}

		if (!validateSubmitData()) {
			return;
		}

		setIsSubmitting(true);

		const rowsInput = [...rowsData];
		rowsInput.map((row) => { if (typeof row.area !== 'string') { row.area = JSON.stringify(row.area) } return true; });
		rowsInput.map((row) => { if (typeof row.line !== 'string') { row.line = JSON.stringify(row.line) } return true; });
		rowsInput.map((row) => { if (typeof row.start_line !== 'string') { row.start_line = JSON.stringify(row.start_line) } return true; });
		rowsInput.map((row) => { if (typeof row.end_line !== 'string') { row.end_line = JSON.stringify(row.end_line) } return true; });
		rowsInput.map((row) => {
			delete row.is_draw_line;
			delete row.is_draw_line_selected;
			delete row.is_end_line_selected;
			delete row.is_full_or_region_selected;
			delete row.is_full_region;
			delete row.is_full_region_selected;
			delete row.is_polygon_region;
			delete row.is_polygon_region_selected;
			delete row.is_select_direction;
			delete row.is_select_direction_selected;
			delete row.is_selected;
			delete row.is_show_all;
			delete row.is_start_end_line;
			delete row.is_start_line_selected;
			return true;
		});

		const body = {
			camera_number: camSelected.camera_number,
			assign: rowsInput,
		};

		addOrUpdateAreaSelectionService(body).then((response) => {
			toast.success(response?.data);
			toast.success("Area selection successfully saved");
			getAllCameraAssignDetails();
			if (camSelected.camera_number) {
				getCurrentCameraAreaDetail(camSelected.camera_number);
			}
			setTimeout(() => <Redirect to="/" />, 5000);
		}).catch((error) => {
			toast.error("Error : Failed to save area selection !!!");
		}).finally(() => {
			setIsSubmitting(false);
		});
	}

	const validateSubmitData = () => {
		return rowsData?.every((row) => {
			if (row?.is_full_region || row?.is_polygon_region) {
				if (!row?.area || row?.area?.length === 0) {
					toast.warn(`Please select region first for model "${row?.model}" !!!`);
					return false;
				}
			}
			if (row?.is_draw_line) {
				if (!row?.line || row?.line?.length === 0) {
					toast.warn(`Please draw line first for model "${row?.model}" !!!`);
					return false;
				}
			}
			if (row?.is_select_direction) {
				if (!row?.direction || row?.direction === "") {
					toast.warn(`Please select direction first for model "${row?.model}" !!!`);
					return false;
				}
			}
			if (row?.is_start_end_line) {
				if (!row?.start_line || row?.start_line?.length === 0) {
					toast.warn(`Please draw start line first for model "${row?.model}" !!!`);
					return false;
				}
				if (!row?.end_line || row?.end_line?.length === 0) {
					toast.warn(`Please draw end line first for model "${row?.model}" !!!`);
					return false;
				}
			}

			return true;
		})
	}

	async function deleteDetails() {
		if (camSelected?.camera_number) {
			const body = {
				camera_number: camSelected.camera_number,
			};

			deleteAreaSelectionService(body).then((response) => {
				if (response?.data) {
					toast.success("Area selection successfully deleted");
				}
				getAllCameraAssignDetails();
			}).catch((error) => {
				toast.error("Error : Failed to delete area selection !!!");
			});
		} else {
			toast.warn("Please select camera first !!!");
		}
	}

	async function getCurrentImageOfSelectedCamera(camera_number) {
		const body = {
			camera_number: camera_number,
		};

		getCameraImageService(body).then((response) => {
			setCurrentCameraImage(response?.data);
		}).catch((error) => {
			toast.error("Error : Failed to get camera image !!!");
		});
	}

	const getCurrentCameraAreaDetail = (camera_number) => {
		try {
			if (camera_number) {
				setRowsData([]);
				setPoints([]);
				if (allCameraDetails && allCameraDetails?.length > 0) {
					let selectedCameraAssignDetail = allCameraDetails.find(
						(x) => x.camera_number === camera_number
					);
					if (selectedCameraAssignDetail) {
						let assignDetails = [...selectedCameraAssignDetail.assign];
						if (assignDetails && assignDetails.length > 0) {
							assignDetails.map((element, index) => {
								let model_data = modelDropDownOptions.find(
									(x) => x.model_name === element?.model
								);

								let area = isJsonString(element?.area)
									? JSON.parse(element?.area)
									: element?.area;
								if (area) {
									element.area = area;
									if (area && area.length > 0) {
										if (JSON.stringify(area) === JSON.stringify(fullImageDetectionArea)) {
											element.is_full_region = true;
											element.is_polygon_region = false;
										} else {

											element.is_full_region = false;
											element.is_polygon_region = true;
										}
									} else {
										if (model_data) {
											element.is_full_region = model_data?.is_full_region;
											element.is_polygon_region = model_data?.is_polygon_region;
										}
									}
								}

								let line = isJsonString(element?.line)
									? JSON.parse(element?.line)
									: element?.line;
								if (line) {
									element.line = line;
									if (line && line.length > 0) {
										element.is_draw_line = true;
										if (model_data) {
											if (model_data?.line_count) {
												element.line_count = model_data?.line_count;
											} else {
												element.line_count = 1;
											}
										}
									} else {
										if (model_data) {
											element.is_draw_line = model_data?.is_draw_line;
											if (model_data?.line_count) {
												element.line_count = model_data?.line_count;
											} else {
												element.line_count = 1;
											}
										}
									}
								}

								let start_line = isJsonString(element?.start_line)
									? JSON.parse(element?.start_line)
									: element?.start_line;
								if (start_line) {
									element.start_line = start_line;
									if (start_line && start_line.length > 0) {
										element.is_start_end_line = true;
									} else {
										if (model_data) {
											element.is_start_end_line = model_data?.is_start_end_line;
										}
									}
								}

								let end_line = isJsonString(element?.end_line)
									? JSON.parse(element?.end_line)
									: element?.end_line;
								if (end_line) {
									element.end_line = end_line;
									if (end_line && end_line.length > 0) {
										element.is_start_end_line = true;
									} else {
										if (model_data) {
											element.is_start_end_line = model_data?.is_start_end_line;
										}
									}
								}

								if (element?.direction && (element?.direction === "up" || element?.direction === "down")) {
									element.is_select_direction = true;
								}

								if (!element?.distance) {
									element.distance = 0;
								}
								element.is_selected = false;
								element.is_show_all = false;
								element.is_draw_line_selected = false;
								element.is_full_or_region_selected = false;
								element.is_start_line_selected = false;
								element.is_end_line_selected = false;
								element.is_select_direction_selected = false;
								element.is_start_end_time = false;
								return true;
							});
							setRowsData(assignDetails);
						}
					}
				}
			}
		} catch (err) {
			console.log(err);
		}
	};

	const cameraChanged = async (option) => {
		setCamSelected(option);
		await getCurrentImageOfSelectedCamera(option.camera_number);
		if (option.camera_number) {
			getCurrentCameraAreaDetail(option.camera_number);
		}
	};

	const setAreaPoints = (newArea) => {
		setPoints(newArea);
		try {
			const rowsInput = [...rowsData];
			if (rowsInput && rowsInput.length > 0) {
				rowsInput[selectedRowIndex].area = newArea;
			}
			setRowsData(rowsInput);
		} catch {

		}
	};

	const setLinePoints = (newArea) => {
		setPoints(newArea);
		try {
			const rowsInput = [...rowsData];
			if (rowsInput && rowsInput.length > 0) {
				rowsInput[selectedRowIndex].line = newArea;
			}
			setRowsData(rowsInput);
		} catch {

		}
	};

	const setStartLinePoints = (newArea) => {
		setPoints(newArea);
		try {
			const rowsInput = [...rowsData];
			if (rowsInput && rowsInput.length > 0) {
				rowsInput[selectedRowIndex].start_line = newArea;
			}
			setRowsData(rowsInput);
		} catch {

		}
	};

	const setEndLinePoints = (newArea) => {
		setPoints(newArea);
		try {
			const rowsInput = [...rowsData];
			if (rowsInput && rowsInput.length > 0) {
				rowsInput[selectedRowIndex].end_line = newArea;
			}
			setRowsData(rowsInput);
		} catch {

		}
	};

	function isJsonString(str) {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}

	const getAllModels = () => {
		getAllModelNamesService()
			.then((response) => {
				setModelDropDownOptions(isJsonString(response?.data) ? JSON.parse(response?.data) : response?.data);
			})
			.catch((err) => {
				toast.error("Error : Failed to get all models !!!");
			});
			console.log('first api works')
	};

	const handlePointsChange = (updatedAssign, index) => {
		if ((selectedRowIndex && selectedRowIndex === index) || (selectedRowIndex === 0 && index === 0)) {
			setRowsData(prevRowsData => {
				const rowsInput = [...prevRowsData];
				if (updatedAssign && updatedAssign?.length > 0) {
					if (rowsInput[index].model !== updatedAssign[0]) {
						rowsInput[index].model = updatedAssign[0];
						setRowsData(rowsInput);
					}
				}
				return rowsInput;
			});
		}
		else {
			toast.warn("Please select row first!!!")
		}
	};

	const handleCoolDownPeroidChange = (index, value) => {
		if ((selectedRowIndex && selectedRowIndex === index) || (selectedRowIndex === 0 && index === 0)) {
			const rowsInput = [...rowsData];
			if (value === 0) {
				rowsInput[index].cool_down_period = 60000;

			} else {
				rowsInput[index].cool_down_period = value;
			}
			setRowsData(rowsInput);
		} else {
			toast.warn("Please select row first!!!")
		}
	};

	const setModelCriteria = (index, value) => {
		if ((selectedRowIndex && selectedRowIndex === index) || (selectedRowIndex === 0 && index === 0)) {
			const rowsInput = [...rowsData];
			rowsInput[index].is_full_region = value?.is_full_region === true ? true : false;
			rowsInput[index].is_polygon_region = value?.is_polygon_region === true ? true : false;
			rowsInput[index].line_count = value?.line_count ?? 0;
			rowsInput[index].is_select_direction = value?.is_select_direction === true ? true : false;
			rowsInput[index].is_start_end_line = value?.is_start_end_line === true ? true : false;
			rowsInput[index].is_draw_line = value?.is_draw_line === true ? true : false;
			setAreaPoints([]);
			setRowsData(rowsInput);
		} else {
			toast.warn("Please select row first!!!")
		}
	}

	const handleDetectionTypeChange = (index, detectionType, value) => {
		if ((selectedRowIndex && selectedRowIndex === index) || (selectedRowIndex === 0 && index === 0)) {
			const rowsInput = [...rowsData];
			if (detectionType === "is_full_or_region_selected") {
				rowsInput[index].is_full_or_region_selected = value;
				rowsInput[index].is_start_line_selected = false;
				rowsInput[index].is_end_line_selected = false;
				rowsInput[index].is_select_direction_selected = false;
				rowsInput[index].is_draw_line_selected = false;
				if (!rowsInput[selectedRowIndex]?.area || rowsInput[selectedRowIndex]?.area?.length === 0) {
					setPoints([]);
				} else {
					setAreaPoints(rowsInput[selectedRowIndex]?.area);
					if (JSON.stringify(rowsInput[selectedRowIndex]?.area) === JSON.stringify(fullImageDetectionArea)) {
						rowsInput[index].is_full_region_selected = true;
						rowsInput[index].is_polygon_region_selected = false;
					} else {
						rowsInput[index].is_full_region_selected = false;
						rowsInput[index].is_polygon_region_selected = true;
					}
				}
			}
			else if (detectionType === "is_draw_line_selected") {
				rowsInput[index].is_draw_line_selected = value;
				rowsInput[index].is_full_or_region_selected = false;
				rowsInput[index].is_start_line_selected = false;
				rowsInput[index].is_end_line_selected = false;
				rowsInput[index].is_select_direction_selected = false;
				if (!rowsInput[selectedRowIndex]?.line || rowsInput[selectedRowIndex]?.line?.length === 0) {
					setPoints([]);
				} else {
					setLinePoints(rowsInput[selectedRowIndex]?.line);
				}
			}
			else if (detectionType === "is_select_direction_selected") {
				rowsInput[index].is_select_direction_selected = value;
				rowsInput[index].is_full_or_region_selected = false;
				rowsInput[index].is_start_line_selected = false;
				rowsInput[index].is_end_line_selected = false;
				rowsInput[index].is_draw_line_selected = false;
				setPoints([]);
			}
			else if (detectionType === "is_start_line_selected") {
				rowsInput[index].is_start_line_selected = value;
				rowsInput[index].is_full_or_region_selected = false;
				rowsInput[index].is_end_line_selected = false;
				rowsInput[index].is_select_direction_selected = false;
				rowsInput[index].is_draw_line_selected = false;
				if (!rowsInput[selectedRowIndex]?.start_line || rowsInput[selectedRowIndex]?.start_line?.length === 0) {
					setPoints([]);
				} else {
					setStartLinePoints(rowsInput[selectedRowIndex]?.start_line);
				}
			}
			else if (detectionType === "is_end_line_selected") {
				rowsInput[index].is_end_line_selected = value;
				rowsInput[index].is_full_or_region_selected = false;
				rowsInput[index].is_start_line_selected = false;
				rowsInput[index].is_select_direction_selected = false;
				rowsInput[index].is_draw_line_selected = false;
				if (!rowsInput[selectedRowIndex]?.end_line || rowsInput[selectedRowIndex]?.end_line?.length === 0) {
					setPoints([]);
				} else {
					setEndLinePoints(rowsInput[selectedRowIndex]?.end_line);
				}
			}
			rowsInput[index].is_show_all = false;
			setRowsData(rowsInput);
		} else {
			toast.warn("Please select row first!!!")
		}
	}

	const handleFullRegionTypeChange = (index, detectionType, value) => {
		if ((selectedRowIndex && selectedRowIndex === index) || (selectedRowIndex === 0 && index === 0)) {
			const rowsInput = [...rowsData];
			if (detectionType === "is_full_region_selected") {
				rowsInput[index].is_full_region_selected = value;
				rowsInput[index].is_polygon_region_selected = false;
				setAreaPoints(fullImageDetectionArea);
			}
			else if (detectionType === "is_polygon_region_selected") {
				rowsInput[index].is_polygon_region_selected = value;
				rowsInput[index].is_full_region_selected = false;
				setAreaPoints([]);
			}
			setRowsData(rowsInput);
		} else {
			toast.warn("Please select row first!!!")
		}
	}

	const handleDirectionChange = (index, value) => {
		if ((selectedRowIndex && selectedRowIndex === index) || (selectedRowIndex === 0 && index === 0)) {
			const rowsInput = [...rowsData];
			rowsInput[index].direction = value;
			setRowsData(rowsInput);
		} else {
			toast.warn("Please select row first!!!")
		}
	}

	const handleSelectRowChange = (index, value) => {
		const rowsInput = [...rowsData];
		rowsInput.map((row) => row.is_selected = false)
		rowsInput[index].is_selected = value === 'true' || rowsInput.length === 1 ? true : false;
		setSelectedRowIndex(index);
		setRowsData(rowsInput);
	}

	const handleDistanceChange = (index, value) => {
		if ((selectedRowIndex && selectedRowIndex === index) || (selectedRowIndex === 0 && index === 0)) {
			const rowsInput = [...rowsData];
			if (rowsInput[index].distance < 0) {
				rowsInput[index].distance = 0;
			} else {
				rowsInput[index].distance = +value;
			}

			setRowsData(rowsInput);
		} else {
			toast.warn("Please select row first!!!")
		}

	}

	const handleShowAllChange = (index, value) => {
		if ((selectedRowIndex && selectedRowIndex === index) || (selectedRowIndex === 0 && index === 0)) {
			const rowsInput = [...rowsData];
			let finalPoints = [];
			if (rowsInput[index]?.area && rowsInput[index].area?.length > 0) {
				finalPoints = [...finalPoints, ...rowsInput[index].area];
			}
			if (rowsInput[index]?.line && rowsInput[index].line?.length > 0) {
				finalPoints = [...finalPoints, ...rowsInput[index].line];
			}
			if (rowsInput[index]?.start_line && rowsInput[index].start_line?.length > 0) {
				finalPoints = [...finalPoints, ...rowsInput[index].start_line];
			}
			if (rowsInput[index]?.end_line && rowsInput[index].end_line?.length > 0) {
				finalPoints = [...finalPoints, ...rowsInput[index].end_line];
			}
			setPoints(finalPoints);
			rowsInput[index].is_show_all = value;
			rowsInput[index].is_draw_line_selected = false;
			rowsInput[index].is_full_or_region_selected = false;
			rowsInput[index].is_start_line_selected = false;
			rowsInput[index].is_end_line_selected = false;
			rowsInput[index].is_select_direction_selected = false;
			setRowsData(rowsInput);
		} else {
			toast.warn("Please select row first!!!")
		}

	}

	const addTableRows = () => {
		const rowsInput = {
			model: "",
			is_show_all: false,
			is_selected: rowsData.length === 0 ? true : false,
			is_full_region: false,
			is_polygon_region: false,
			is_draw_line: false,
			line_count: 1,
			is_select_direction: false,
			is_start_end_line: false,
			is_full_region_selected: false,
			is_polygon_region_selected: false,
			is_draw_line_selected: false,
			is_select_direction_selected: false,
			is_start_line_selected: false,
			is_end_line_selected: false,
			is_full_or_region_selected: false,
			alert_start_time: '00:00',
			alert_end_time: '00:00',
			cool_down_period: 60000,
			distance: 1,
			direction: "up",
			area: [],
			line: [],
			start_line: [],
			end_line: [],
		};
		setRowsData((prev) => [...prev, rowsInput]);
		if (rowsData.length === 0) {
			setSelectedRowIndex(0)
		}
	};

	const deleteTableRows = (index) => {
		const rows = [...rowsData];
		rows.splice(index, 1);
		setRowsData(rows);
	};

	const handleAlertStartTimeChange = (index, value) => {
		if ((selectedRowIndex && selectedRowIndex === index) || (selectedRowIndex === 0 && index === 0)) {
			const rowsInput = [...rowsData];
			rowsInput[index].alert_start_time = value.target.value;
			setRowsData(rowsInput);
		} else {
			toast.warn("Please select row first!!!")
		}
	};

	const handleAlertEndTimeChange = (index, value) => {
		if ((selectedRowIndex && selectedRowIndex === index) || (selectedRowIndex === 0 && index === 0)) {
			const rowsInput = [...rowsData];
			rowsInput[index].alert_end_time = value.target.value;
			setRowsData(rowsInput);
		} else {
			toast.warn("Please select row first!!!")
		}
	};

	useEffect(() => {
		getAllModels();
		getAllCameraAssignDetails();
	}, []);

	useEffect(() => {
		if (camSelected?.camera_number) {
			getCurrentCameraAreaDetail(camSelected.camera_number);
		}
	}, [allCameraDetails]);

	return (
		<div className="modern-area-selection">
			{/* <div className="modern-header"> */}
				{/* <div className="header-content"> */}
					<h1 className="page-title">Area Selection</h1>
					<p className="page-subtitle">Configure detection zones and model assignments</p>
				{/* </div> */}
			{/* </div> */}

			<div className="modern-container">
				<div className="content-grid">
					<div className="left-panel">
						{/* Camera Selection Card */}
						<div className="modern-card camera-card">
							<div className="card-header">
								<div className="header-icon">
									<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
										<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
										<circle cx="12" cy="13" r="4"/>
									</svg>
								</div>
								<h2 className="card-title">Camera Selection</h2>
							</div>
							<CamSelection
								selectedCamera={camSelected}
								setSelectedCamera={cameraChanged}
							/>
						</div>

						{/* Model Assignment Card */}
						<div className="modern-card assignment-card">
							<div className="card-header">
								<div className="header-icon">
									<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
										<rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
										<line x1="9" y1="9" x2="15" y2="9"/>
										<line x1="9" y1="15" x2="15" y2="15"/>
									</svg>
								</div>
								<h2 className="card-title">Model Assignment</h2>
								{rowsData.length > 0 && (
									<span className="badge">{rowsData.length} {rowsData.length === 1 ? 'model' : 'models'}</span>
								)}
							</div>
							<AddDeleteTableRows
								modelDropDownOptions={modelDropDownOptions}
								selectedCamera={camSelected}
								rowsData={rowsData}
								addTableRows={addTableRows}
								deleteTableRows={deleteTableRows}
								handleAlertStartTimeChange={handleAlertStartTimeChange}
								handleAlertEndTimeChange={handleAlertEndTimeChange}
								handlePointsChange={handlePointsChange}
								handleCoolDownPeroidChange={handleCoolDownPeroidChange}
								handleDetectionTypeChange={handleDetectionTypeChange}
								handleDirectionChange={handleDirectionChange}
								handleFullRegionTypeChange={handleFullRegionTypeChange}
								handleSelectRowChange={handleSelectRowChange}
								setModelCriteria={setModelCriteria}
								handleDistanceChange={handleDistanceChange}
								handleShowAllChange={handleShowAllChange}
							/>
						</div>
					</div>

					<div className="right-panel">
						{/* Preview Card */}
						<div className="modern-card preview-card">
							<div className="card-header">
								<div className="header-icon">
									<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
										<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/>
										<line x1="8" y1="2" x2="8" y2="18"/>
										<line x1="16" y1="6" x2="16" y2="22"/>
									</svg>
								</div>
								<h2 className="card-title">Preview</h2>
								{camSelected && (
									<span className="camera-label">Camera {camSelected.camera_number}</span>
								)}
							</div>
							{camSelected ? (
								<div className="preview-content">
									<PolygonStateHandler
										points={points}
										currentCameraImage={currentCameraImage}
										setLinePoints={setLinePoints}
										setStartLinePoints={setStartLinePoints}
										setEndLinePoints={setEndLinePoints}
										setAreaPoints={setAreaPoints}
										selectedRowIndex={selectedRowIndex}
										rowsData={rowsData}
									/>
								</div>
							) : (
								<div className="empty-preview">
									<svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
										<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
										<circle cx="12" cy="13" r="4"/>
									</svg>
									<p>Select a camera to preview</p>
								</div>
							)}
						</div>
					</div>
				</div>

				{/* Action Bar */}
				<div className="action-bar">
					<div className="action-buttons">
						<button 
							className="action-btn reset-btn" 
							onClick={() => setPoints([])}
							title="Reset selection"
						>
							<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
								<polyline points="1 4 1 10 7 10"/>
								<polyline points="23 20 23 14 17 14"/>
								<path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
							</svg>
							Reset
						</button>
						<button 
							className="action-btn delete-btn" 
							onClick={deleteDetails}
							title="Delete configuration"
						>
							<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
								<polyline points="3 6 5 6 21 6"/>
								<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
								<line x1="10" y1="11" x2="10" y2="17"/>
								<line x1="14" y1="11" x2="14" y2="17"/>
							</svg>
							Delete
						</button>
						<button 
							className="action-btn submit-btn" 
							onClick={sendDetails}
							disabled={isSubmitting}
							title="Save configuration"
						>
							{isSubmitting ? (
								<>
									<span className="spinner"></span>
									Saving...
								</>
							) : (
								<>
									<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
										<polyline points="20 6 9 17 4 12"/>
									</svg>
									Submit
								</>
							)}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AreaSelection;